import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconMove = (props) => (
  <SvgIcon {...props}>
    <g>
      <path d="M11.4,18.1c2.4,0,6.1,0,8.5,0c0.7,0,1.1,0.6,0.9,1.2c-0.1,0.4-0.5,0.6-0.9,0.6c-1.7,0-4.7,0-6.5,0
		c-3.1,0-6.2,0-9.3,0c-0.8,0-1.3-0.7-0.9-1.4c0.2-0.3,0.5-0.5,0.9-0.5c2.2,0,4.4,0,6.7,0C11,18.1,11.2,18.1,11.4,18.1z"/>
      <path d="M11.4,11.1c2.4,0,6.1,0,8.5,0c0.7,0,1.2,0.6,0.9,1.2c-0.1,0.4-0.5,0.6-0.9,0.6c-1.4,0-4.1,0-5.5,0
		c-3.4,0-6.8,0-10.3,0c-0.7,0-1.2-0.6-0.9-1.3c0.2-0.4,0.5-0.6,0.9-0.6c2.2,0,4.4,0,6.7,0C11,11.1,11.2,11.1,11.4,11.1z"/>
      <path d="M11.4,4c2.4,0,6.1,0,8.5,0c0.7,0,1.2,0.6,0.9,1.2c-0.1,0.4-0.5,0.6-0.9,0.6c-1.4,0-4.1,0-5.5,0
		c-3.4,0-6.8,0-10.3,0c-0.7,0-1.2-0.6-0.9-1.3C3.4,4.2,3.7,4,4.1,4c2.2,0,4.4,0,6.6,0C11,4,11.2,4,11.4,4z"/>
    </g>
  </SvgIcon>
);

IconMove.displayName = 'IconMove';
IconMove.muiName = 'SvgIcon';

export default IconMove;



// WEBPACK FOOTER //
// ./src/components/Icons/IconMove.js